import React from 'react';
import { OrderFulfillmentStatus } from '../../../../services/exports/Constants';
import ScheduledOrderStartPreparation from './ScheduledOrderStartPreparation';
import OrderTimeChange from './OrderTimeChange';
import OldOrder from './OldOrder';

export default function Footer(props) {
  const { order } = props;

  const scheduledOrderStartPreparation = <ScheduledOrderStartPreparation {...props} />;
  const orderTimeChange = <OrderTimeChange {...props} />;
  const oldOrder = <OldOrder {...props} />;

  if (
    (!order.is_manually_confirmed && order.fulfillment_status !== OrderFulfillmentStatus.Rejected) ||
    order.fulfillment_status === OrderFulfillmentStatus.Created ||
    order.fulfillment_status === OrderFulfillmentStatus.Reviewed
  ) {
    return null;
  }

  return (
    {
      [OrderFulfillmentStatus.Accepted]: order.scheduled_for ? scheduledOrderStartPreparation : orderTimeChange,
      [OrderFulfillmentStatus.Preparing]: orderTimeChange,
      [OrderFulfillmentStatus.Ready]: orderTimeChange,
      [OrderFulfillmentStatus.OnDelivery]: orderTimeChange,
    }[order.fulfillment_status] ?? oldOrder
  );
}
